export const formatPrice = (price: number, currency: string = 'USD', locale: string = 'fr-FR'): string => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

export const formatPricePerNight = (price: number, nights: number, currency: string = 'USD'): string => {
  const pricePerNight = Math.round(price / nights);
  return formatPrice(pricePerNight, currency);
};

export const formatPriceWithNights = (price: number, nights: number, currency: string = 'USD'): string => {
  const formattedPrice = formatPrice(price, currency);
  return `${formattedPrice} pour ${nights} nuits`;
};